export default __webpack_public_path__ + "assets/images/Payment_05.f03518.png";